import React, { createContext, ReactNode, useContext } from "react";

interface DragDropContextValue {
  // Simplified for now - will be expanded as needed
  isDragging: boolean;
  draggedItem: any | null;
}

const DragDropContext = createContext<DragDropContextValue | undefined>(undefined);

export const useDragDropContext = () => {
  const context = useContext(DragDropContext);
  if (context === undefined) {
    throw new Error("useDragDropContext must be used within a DragDropProvider");
  }
  return context;
};

interface DragDropProviderProps {
  children: ReactNode;
}

export const DragDropProvider: React.FC<DragDropProviderProps> = ({ children }) => {
  const value: DragDropContextValue = {
    isDragging: false,
    draggedItem: null,
  };

  return <DragDropContext.Provider value={value}>{children}</DragDropContext.Provider>;
};
